import React from 'react';

import { Loader } from 'components/loader/Loader';

const SettingsPage = React.lazy(() =>
  import(/* webpackChunkName: "admin-settings-page" */ './SettingsPage'),
);

export default (props: any) => (
  <React.Suspense fallback={<Loader />}>
    <SettingsPage {...props} />
  </React.Suspense>
);
